import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import _ from 'lodash';
import { ModalContext } from 'App';
import { customStyle } from 'helper';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import * as actions from '../action';
import * as c from '../constant';

const rules = {
  rptax_land_classification_id: 'required',
  assessment_level: 'required',
  ordinance_revision_id: 'required',
};

function CreateModal({
  formData,
  setFormData,
  getLandClassificationsList,
  landClassificationsList,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  createAssessmentLevel,
  isLoading,
  history,
  getAssessmentLevelList,
}) {
  const setModal = useContext(ModalContext);
  const validateForm = useFormValidator(formData, rules);

  const landClassificationsOptions = landClassificationsList.map((x) => {
    return {
      label: x?.attributes?.name,
      value: x.id,
      id: x.id,
    };
  });

  const ordinanceRevisionOptions = ordinanceRevisionList.map((x) => {
    return {
      label: x?.attributes?.name,
      value: x.id,
      id: x.id,
    };
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();
    createAssessmentLevel(formData, (data) => {
      setModal({ isOpen: false });
      getAssessmentLevelList();
      history.push(
        `/rpt/machinery/machinery-settings/assessment-level/${data.data.id}`
      );
    });
  };

  const handleOnClose = (e) => {
    if (e) e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  useEffect(() => {
    getLandClassificationsList();
  }, []);

  useEffect(() => {
    getOrdinanceRevisionList();
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label
              htmlFor="rptax_land_classification_id"
              className="form-label mb-0"
            >
              Machinery Classification &nbsp;{' '}
              {validateForm.renderMessage('rptax_land_classification_id')}
            </label>
            <Select
              options={landClassificationsOptions}
              styles={{
                ...customStyle,
                control: (base) => ({
                  ...customStyle.control(base),
                  height: 37,
                  minHeight: 37,
                }),
              }}
              placeholder="-Select-"
              value={landClassificationsOptions.find(
                (item) =>
                  item.value === _.get(formData, 'rptax_land_classification_id')
              )}
              onChange={handleOnChangeSelect('rptax_land_classification_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="assessment_level" className="form-label mb-0">
              Assessment Level &nbsp;{' '}
              {validateForm.renderMessage('assessment_level')}
            </label>
            <input
              className="form-control"
              type="number"
              name="assessment_level"
              onChange={handleOnChange('assessment_level')}
              value={_.get(formData, 'assessment_level') || ''}
              min="0"
              placeholder="Enter Assessment Level"
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="ordinance_revision_id" className="form-label mb-0">
              Ordinance Revision &nbsp;{' '}
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <Select
              options={ordinanceRevisionOptions}
              styles={{
                ...customStyle,
                control: (base) => ({
                  ...customStyle.control(base),
                  height: 37,
                  minHeight: 37,
                }),
              }}
              placeholder="-Select-"
              value={ordinanceRevisionOptions.find(
                (item) =>
                  item.value === _.get(formData, 'ordinance_revision_id')
              )}
              onChange={handleOnChangeSelect('ordinance_revision_id')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4">
          <button
            type="submit"
            className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary  mr-1 cms-bg-color-primary"
            disabled={!validateForm.response.is_passed || isLoading}
          >
            Submit
          </button>
          <button
            type="button"
            onClick={handleOnClose}
            className="btn btn-light ml-1"
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.defaultProps = {};

CreateModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  landClassificationsList: PropTypes.instanceOf(Array).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
  createAssessmentLevel: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getAssessmentLevelList: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  landClassificationsList:
    _.get(api, `${c.GET_LAND_CLASSIFICATIONS_LIST}.list`) || [],
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.CREATE_ASSESSMENT_LEVEL) > -1,
});

const enhance = _.flowRight([
  withRouter,
  withForm,
  connect(mapStateToProps, actions),
]);

export default enhance(CreateModal);
